import { useEffect } from 'react';
import '@/index.css';
import { lazy, Suspense } from 'react';
import App from '@/App';
import '@/Asset/Font-family/GoodTimesRg-Regular.ttf';
import '@/Asset/Font-family/GoodTimesRg-Regular.woff';
import '@/Asset/Font-family/GoodTimesRg-Regular.eot';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuthHydration } from '@/hook/useAuthHydration';
import Savedvideos from '@/component/SavedVideo/Savedvideos';
import ForgotPassword from '@/component/ForgetPassword/ForgotPassword';
import RestPassword from '@/component/ForgetPassword/RestPassword';
import StudioPlanPage from '@/component/StudioPlanPage';
import VideoSection from '@/component/VideoSection';
import StudioSignUp from '@/component/StudioSignUp';
import History from '@/component/History';
import AllVideos from '@/AdminComponent/AllVideos';
import AdminDashboard from '@/Layouts/AdminLayout/AdminDashboard';
import AddCategory from '@/AdminComponent/AddCategory';
import AddVideos from '@/AdminComponent/AddVideos';
import TagManagement from '@/AdminComponent/TagManagement';
import AllUsers from '@/AdminComponent/AllUsers';
import Instructors from '@/AdminComponent/Instructors';
import '@/App.css';
import FeaturedPlayListForm from '@/component/playlist/featured-playlist/FeaturedPlayListForm';
import PersonalPlayListForm from '@/component/playlist/personal-playlist/PersonalPlayListForm';
import { Provider } from 'react-redux';
import { store } from '@/redux/store';
import { HelmetProvider } from 'react-helmet-async';
import FeaturedPlaylistManager from '@/AdminComponent/FeaturedPlaylists/FeaturedPlaylistManager';
import FeaturedPlaylistEditor from '@/AdminComponent/FeaturedPlaylists/FeaturedPlaylistEditor';
import SearchPageList from '@/component/searchPage/SearchPageList';
import MyAccountV2 from '@/component/My Account/MyAccountV2';
import AdminModeration from '@/component/AdminModeration/AdminModeration';
import AdminNotification from '@/component/AdminNotification/AdminNotification';
import SetSubUserPassword from '@/component/SetSubUserPassword';
import ScrollToTop from '@/ScrollToTop';
import NewLogin from '@/Pages/auth/Login/NewLogin';
import { Banners, EditBanners, AddBanners } from '@/Pages/admin/Banners';
import Loader from '@/component/LoderComponent';
import { useAtomValue } from 'jotai';
import { loaderState } from '@/data/atoms/utilsAtoms';
import StudioPlayList from '@/component/playlist/studio-playlist/StudioPlayList';
import SitemapGenerator from '@/Pages/Sitemap/SiteMap';
import CheckVideoType from '@/AdminComponent/CheckVideoType';
import AddClassVideos from '@/AdminComponent/AddClassVideos';
import { useAnalytics } from '@/hook/useAnalytics';
import PlayerPage from '@/Pages/VideoPlayer/PlayerPage';
import { RedirectToPlayerPage } from '@/Pages/VideoPlayer/RedirectToPlayerPage';
import ClassVideos from '@/component/Classes/ClassVideos';
import { Lesson as V2Lesson } from '@/v2/pages/Lesson';
import { Exercise as V2Exercise } from '@/v2/pages/Exercise';
import { AcrossTheFloor as V2AcrossTheFloor } from '@/v2/pages/AcrossTheFloor';
import { AllVideos as V2AllVideos } from '@/v2/pages/AllVideos';
import { AllPlaylists as V2AllPlaylists } from '@/v2/pages/AllPlaylists';
import { FeaturedPlayList as V2FeaturedPlayList } from '@/v2/pages/FeaturedPlayList';
import { PersonalPlayList as V2PersonalPlayList } from '@/v2/pages/PersonalPlayList';
import Pricing from '@/v2/pages/Plans';
import MaintenanceModal from '@/atomicComponent/MaintenanceModal/MaintenanceModal';
import { loadAuthToken } from '@/data/utils/axiosConfigInstance';
import { Popups, AddPopups, EditPopups } from '@/Pages/admin/Popup';
import AddVideosMux from '@/AdminComponent/AddVideoForm';
import TRCLessonPlans from '@/TRC/pages/LessonPlans/LessonPlans';
import TRCResources from '@/TRC/pages/Resources/Resources';
import TRCVideos from '@/TRC/pages/Videos/Videos';
import TRCViewAll from '@/TRC/pages/ViewAll/ViewAll';
import TRCVideo from '@/TRC/pages/Videos/slug/Video';
import TRCResource from '@/TRC/pages/Resources/slug/Resource';
import TRCLessonPlan from '@/TRC/pages/LessonPlans/slug/LessonPlan';
import TRCHome from '@/TRC/pages/Home/Home';
import TRCLayout from '@/Layouts/TRCLayout/Layout';
import TRCSearchPage from '@/TRC/pages/Search/Search';
import TRCAccessPage from '@/TRC/pages/Access/Access';
import ProtectedTRC from '@/Layouts/TRCLayout/ProtectedTRC';
import TeacherResourceCenter from '@/Pages/admin/TeacherResourceCenter';
import { ReleaseAudit } from '@/AdminComponent/ReleaseAudit';
import TRCResubmit from '@/TRC/pages/Access/Resubmit';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import LessonPlanList from '@/Pages/LessonPlan/LessonPlanList';
import LessonPlanDetail from '@/Pages/LessonPlan/LessonPlanDetail';
import ReactionsV2 from '@/AdminComponent/Reactions';
import ReactionStats from '@/AdminComponent/Reactions/ReactionStats';
import CheckoutPage from './v2/pages/CheckOutPage/CheckoutPage';
import AuditLogsPage from '@/Pages/AuditLogsPage';
import AdminAnalyticsDashboard from '@/Pages/admin/Analytics/AdminAnalyticsDashboard';
import UserEngagementAnalytics from '@/Pages/admin/UserEngagement/UserEngagementAnalytics';
import ChargebeeAnalyticsDashboard from '@/Pages/admin/ChargebeePortal/ChargebeeAnalyticsDashboard';
import { LessonPlanManagement, LessonPlanForm } from '@/Pages/admin/LessonPlan';
import SubtitleGenerator from '@/AdminComponent/SubtitleGenerator';
import Cancellations from '@/AdminComponent/Cancellations';
import AppErrorBoundary from '@/component/ErrorBoundery/AppErrorBoundary';
import SessionManager from '@/component/SessionManager';
import OnboardingLayout from '@/Pages/Onboarding/OnboardingLayout';
import CreateProfile from '@/Pages/Onboarding/components/createProfile/CreateProfile';
import SelectPlan from '@/Pages/Onboarding/components/selectPlan/SelectPlan';
import Checkout from '@/Pages/Onboarding/components/checkout/Checkout';
import Welcome from '@/Pages/Onboarding/components/welcome/Welcome';
import Step1 from '@/Pages/Onboarding/components/step1/Step1';
import Step2 from '@/Pages/Onboarding/components/step2/Step2';
import Step3 from '@/Pages/Onboarding/components/step3/Step3';
import Step4 from '@/Pages/Onboarding/components/step4/Step4';
import Step5 from '@/Pages/Onboarding/components/step5/Step5';
import Step6 from '@/Pages/Onboarding/components/step6/Step6';
import RecommendedVideos from '@/Pages/Onboarding/components/recommendedPlaylist/RecommendedPlaylist';
import ZendeskController from '@/component/ZendeskController';
import SyncStudioViews from '@/Pages/admin/SyncStudioViews/SyncStudioViews';
const AdvancedJumpsLanding = lazy(() => import('@/Pages/Promotions/AdvancedJumps/AdvancedJumpsLanding'));
const AdvancedJumpsConfirmation = lazy(() => import('@/Pages/Promotions/AdvancedJumps/AdvancedJumpsConfirmation'));
const StudioLessonPlansLanding = lazy(() => import('@/Pages/Promotions/StudioLessonPlans/StudioLessonPlansLanding'));
const StudioLessonPlansDownload = lazy(() => import('@/Pages/Promotions/StudioLessonPlans/StudioLessonPlansDownload'));
const StudioLessonPlansConfirmation = lazy(
	() => import('@/Pages/Promotions/StudioLessonPlans/StudioLessonPlansConfirmation')
);
const LinkInBioPublic = lazy(() => import('@/Pages/Links/LinkInBioPublic'));
const LinkManagement = lazy(() => import('@/Pages/admin/LinkManagement/LinkManagement'));
const ALaSecondeLanding = lazy(() => import('@/Pages/Promotions/a-la-seconde-funnel/ALaSecondeLanding'));
const ALaSecondeConfirmation = lazy(() => import('@/Pages/Promotions/a-la-seconde-funnel/ALaSecondeConfirmation'));

const LEGACY_SIGNUP_PATH = 'signup';

const LegacySignupRedirect = () => {
	const location = useLocation();

	return <Navigate to={`/onboarding/create-profile${location.search}${location.hash}`} replace />;
};

const LegacySignupRedirectGuard = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const firstPathSegment = location.pathname.replace(/^\/+/, '').split('/')[0].toLowerCase();

		if (firstPathSegment === LEGACY_SIGNUP_PATH) {
			navigate(`/onboarding/create-profile${location.search}${location.hash}`, { replace: true });
		}
	}, [location.hash, location.pathname, location.search, navigate]);

	return null;
};

function RootApp() {
	const isApplicationInLoadingState = useAtomValue(loaderState);
	const isAuthHydrated = useAuthHydration();
	useAnalytics();

	const maintanance = {
		force: false,
		title: 'Scheduled Maintenance Break',
		message: `
          We're currently performing scheduled maintenance to enhance your experience on The Godfrey Method. During this time, the website and app will be temporarily unavailable.

          Maintenance Window:
          09:10 PM – 09:40 PM, 06-10-2026 UTC

          We apologize for the inconvenience and appreciate your patience. We'll be back online shortly—stronger and better!

          – The Godfrey Method Team
            `
	};

	const adminRoutes = [
		{ path: 'AddCategory', element: <AddCategory /> },
		{ path: 'AllVideos', element: <AllVideos /> },
		{ path: 'AddVideos(vimeo)', element: <AddVideos /> },
		{ path: 'AddVideos', element: <AddVideosMux /> },
		{ path: 'Reaction', element: <ReactionsV2 /> },
		{ path: 'Analytics', element: <AdminAnalyticsDashboard /> },
		{ path: 'UserEngagement', element: <UserEngagementAnalytics /> },
		{ path: 'Reaction/reaction-stats', element: <ReactionStats /> },
		{ path: 'Instructors', element: <Instructors /> },
		{ path: 'AddClassVideos', element: <AddClassVideos /> },
		{ path: 'Check', element: <CheckVideoType /> },
		{ path: 'AllUsers', element: <AllUsers /> },
		{ path: 'TagManagement', element: <TagManagement /> },
		{ path: 'featured-playlist', element: <FeaturedPlaylistManager /> },
		{ path: 'featured-playlist/new', element: <FeaturedPlaylistEditor /> },
		{ path: 'featured-playlist/:id/edit', element: <FeaturedPlaylistEditor /> },
		// Legacy path from the old admin form; now opens the new editor in "create" mode.
		{ path: 'featured-playlist-form', element: <FeaturedPlaylistEditor /> },
		{ path: 'moderation', element: <AdminModeration /> },
		{ path: 'notification', element: <AdminNotification /> },
		{ path: 'banners', element: <Banners /> },
		{ path: 'add-banner', element: <AddBanners /> },
		{ path: 'edit-banner/:id', element: <EditBanners /> },
		{ path: 'popup', element: <Popups /> },
		{ path: 'add-popup', element: <AddPopups /> },
		{ path: 'edit-popup/:id', element: <EditPopups /> },
		{ path: 'trc-approval', element: <TeacherResourceCenter.Approval /> },
		{ path: 'trc-content', element: <TeacherResourceCenter.Content /> },
		{ path: 'trc-edit/:id', element: <TeacherResourceCenter.EditContent /> },
		{ path: 'trc-add', element: <TeacherResourceCenter.AddContent /> },
		{ path: 'release-audit', element: <ReleaseAudit /> },
		{ path: 'audit-logs', element: <AuditLogsPage /> },
		{ path: 'chargebee-portal', element: <ChargebeeAnalyticsDashboard /> },
		{ path: 'lesson-plans', element: <LessonPlanManagement /> },
		{ path: 'add-lesson-plan', element: <LessonPlanForm /> },
		{ path: 'edit-lesson-plan/:id', element: <LessonPlanForm /> },
		{ path: 'subtitle-generator', element: <SubtitleGenerator /> },
		{ path: 'cancellations', element: <Cancellations /> },
		{ path: 'sync-studio-views', element: <SyncStudioViews /> },
		{
			path: 'links',
			element: (
				<Suspense fallback={<Loader />}>
					<LinkManagement />
				</Suspense>
			)
		}
	];

	//routes which have userLayouts
	const userRoutes = [
		{ path: 'classes', element: <ClassVideos /> },
		{ path: 'home', element: <VideoSection /> },
		{ path: 'studioPlans', element: <StudioPlanPage /> },
		{ path: 'plans', element: <Pricing /> },
		{ path: 'plan', element: <Pricing /> },
		// { path: 'checkout/:planId/:cbItem', element: <CheckoutPage/> },
		{ path: 'AcrossTheFloor', element: <V2AcrossTheFloor /> },
		{ path: 'Exercises', element: <V2Exercise /> },
		{ path: 'Lessons', element: <V2Lesson /> },
		{ path: 'AllVideos', element: <V2AllVideos /> },
		{ path: 'saved', element: <Savedvideos /> },
		{ path: 'History', element: <History /> },
		{ path: 'account', element: <MyAccountV2 /> },
		{ path: 'set-password/:id', element: <SetSubUserPassword /> },
		{ path: 'result', element: <SearchPageList /> },
		{ path: 'featured-playlist', element: <V2FeaturedPlayList /> },
		{ path: 'all-playlist', element: <V2AllPlaylists /> },
		{ path: 'personal-playlist', element: <V2PersonalPlayList /> },
		{ path: 'studio-playlist', element: <StudioPlayList /> },
		{ path: 'featured-playlist-form', element: <FeaturedPlayListForm /> },
		{ path: 'personal-playlist-form', element: <PersonalPlayListForm /> },
		{ path: 'lesson-plan', element: <LessonPlanList /> },
		{ path: 'lesson-plan/:id', element: <LessonPlanDetail /> },
		{ path: 'PlayerPage', element: <PlayerPage /> },
		{ path: 'v/PlayerPage', element: <PlayerPage /> },
		{ path: 'featured-playlist-view/:playlist/:id', element: <RedirectToPlayerPage /> },
		{ path: 'personal-playlist-view/:playlist/:id', element: <RedirectToPlayerPage /> },
		{ path: 'studio-playlist-view/:playlist/:id', element: <RedirectToPlayerPage /> }
	];

	const trcRoutes = [
		{ path: TRC_ROUTES.LESSON_PLANS, element: <TRCLessonPlans /> },
		{
			path: TRC_ROUTES.PROGRESSIVE_LESSON_PLANS,
			element: <LessonPlanList title="Progressive Lessons" basePath="trc/progressive-lesson-plans" />
		},
		{ path: TRC_ROUTES.RESOURCES, element: <TRCResources /> },
		{ path: TRC_ROUTES.VIDEOS, element: <TRCVideos /> },
		{ path: TRC_ROUTES.VIEW_ALL, element: <TRCViewAll /> },
		{ path: TRC_ROUTES.SINGLE_VIDEO, element: <TRCVideo /> },
		{ path: TRC_ROUTES.SINGLE_RESOURCE, element: <TRCResource /> },
		{ path: TRC_ROUTES.SINGLE_LESSON_PLAN, element: <TRCLessonPlan /> },
		{ path: TRC_ROUTES.SINGLE_PROGRESSIVE_LESSON_PLAN, element: <LessonPlanDetail /> },
		{ path: TRC_ROUTES.SEARCH, element: <TRCSearchPage /> }
	];

	if (!isAuthHydrated) {
		return (
			<HelmetProvider>
				<Provider store={store}>
					<Loader />
				</Provider>
			</HelmetProvider>
		);
	}

	return (
		<HelmetProvider>
			<Provider store={store}>
				{maintanance.force && <MaintenanceModal title={maintanance.title} message={maintanance.message} />}
				{isApplicationInLoadingState && <Loader />}
				<Router>
					<ZendeskController />
					<LegacySignupRedirectGuard />
					<SessionManager />
					<AppErrorBoundary>
						<ScrollToTop>
							<Routes>
								<Route path="/onboarding/*" element={<OnboardingLayout />}>
									<Route path="create-profile" element={<CreateProfile />} />
									<Route path="select-plan" element={<SelectPlan />} />
									<Route path="checkout" element={<Checkout />} />
									<Route path="welcome" element={<Welcome />} />
									<Route path="step-1" element={<Step1 />} />
									<Route path="step-2" element={<Step2 />} />
									<Route path="step-3" element={<Step3 />} />
									<Route path="step-4" element={<Step4 />} />
									<Route path="step-5" element={<Step5 />} />
									<Route path="step-6" element={<Step6 />} />
									<Route path="recommended-videos" element={<RecommendedVideos />} />
								</Route>
								<Route path="/AdminDashboard/*" element={<AdminDashboard />}>
									{adminRoutes.map(route => (
										<Route key={route.path} path={route.path} element={route.element} />
									))}
								</Route>

								{/* public routes */}
								<Route
									path="/advanced-jumps-free-video-signup"
									element={
										<Suspense fallback={<Loader />}>
											<AdvancedJumpsLanding />
										</Suspense>
									}
								/>
								<Route
									path="/advanced-jumps-free-video-signup/confirmation"
									element={
										<Suspense fallback={<Loader />}>
											<AdvancedJumpsConfirmation />
										</Suspense>
									}
								/>
								<Route
									path="/teach-pirouettes-lesson-plan-signup"
									element={
										<Suspense fallback={<Loader />}>
											<StudioLessonPlansLanding />
										</Suspense>
									}
								/>
								<Route
									path="/teach-pirouettes-lesson-plan-signup/confirmation"
									element={
										<Suspense fallback={<Loader />}>
											<StudioLessonPlansConfirmation />
										</Suspense>
									}
								/>
								<Route
									path="/teach-pirouettes-lesson-plan-signup/download"
									element={
										<Suspense fallback={<Loader />}>
											<StudioLessonPlansDownload />
										</Suspense>
									}
								/>
								<Route
									path="/links"
									element={
										<Suspense fallback={<Loader />}>
											<LinkInBioPublic />
										</Suspense>
									}
								/>
								<Route
									path="/a-la-seconde-lesson-plan-signup"
									element={
										<Suspense fallback={<Loader />}>
											<ALaSecondeLanding />
										</Suspense>
									}
								/>
								<Route
									path="/a-la-seconde-lesson-plan-signup/confirmation"
									element={
										<Suspense fallback={<Loader />}>
											<ALaSecondeConfirmation />
										</Suspense>
									}
								/>
								<Route path="/sitemap" element={<SitemapGenerator />} />
								<Route path="/Login" element={<NewLogin />} />
								<Route path="/SignUp" element={<LegacySignupRedirect />} />
								<Route path="/StudioSignUp" element={<StudioSignUp />} />
								<Route path="/forgot" element={<ForgotPassword />} />
								<Route path="/reset_password/:id/:token" element={<RestPassword />} />
								<Route path="/trc/*" element={<TRCLayout />}>
									<Route
										index
										element={
											<ProtectedTRC>
												<TRCHome />
											</ProtectedTRC>
										}
									/>
									{trcRoutes.map(route => (
										<Route key={route.path} path={route.path} element={<ProtectedTRC>{route.element}</ProtectedTRC>} />
									))}
									<Route path={TRC_ROUTES.ACCESS} element={<TRCAccessPage />} />
									<Route path={TRC_ROUTES.RESUBMIT} element={<TRCResubmit />} />
								</Route>
								<Route path="/studio-hub/*" element={<TRCLayout />}>
									<Route
										index
										element={
											<ProtectedTRC>
												<TRCHome />
											</ProtectedTRC>
										}
									/>
									<Route path={TRC_ROUTES.LESSON_PLANS} element={<ProtectedTRC><LessonPlanList /></ProtectedTRC>} />
									{trcRoutes.filter(r => r.path !== TRC_ROUTES.LESSON_PLANS).map(route => (
										<Route key={route.path} path={route.path} element={<ProtectedTRC>{route.element}</ProtectedTRC>} />
									))}
									<Route path={TRC_ROUTES.ACCESS} element={<TRCAccessPage />} />
									<Route path={TRC_ROUTES.RESUBMIT} element={<TRCResubmit />} />
								</Route>

								{/*Exception because "/" cannot be handled by "/*" */}
								<Route
									path="/"
									element={
										<App>
											<VideoSection />
										</App>
									}
								/>

								{/*User Routes */}
								<Route path="/*" element={<App />}>
									{userRoutes.map(route => (
										<Route key={route.path} path={route.path} element={route.element} />
									))}
								</Route>
							</Routes>
						</ScrollToTop>
					</AppErrorBoundary>
				</Router>
			</Provider>
		</HelmetProvider>
	);
}

export default RootApp;
